import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import {
  QualityCheck,
  ApplicableRecommendationData,
  GeneratedContentValidationNew,
} from '../../../types/contentValidation';
import { QcReviewName } from '../../../types/QualityChecks';

export type QualityValidationState = {
  isLoading: boolean;
  isPolling: boolean;
  error?: boolean;
  errorMessage?: string;
  qualityChecks: QualityCheck[];
  needsReviewCount: number;
  applicableRecommendations: ApplicableRecommendationData[];
  status?: QcReviewName;
  validationId?: string;
  validationData?: GeneratedContentValidationNew;
  selectedRecommendationIds?: Set<string>;
  retryParams: {
    contentId: string;
    sessionId: string;
    contentGroupId: string;
    action: string;
  };
  retryCount: number;
};

export type QualityValidationStateSegmentType = Record<
  string,
  QualityValidationState
>;

export const qualityValidationStateSegment =
  stateSegmentWithReset<QualityValidationStateSegmentType>({});

qualityValidationStateSegment.debugLabel = 'qualityValidationStateSegment';

// Utility function to check if any item has "NEEDS_REVIEW" status
export const hasNeedsReview = (
  data: QualityValidationStateSegmentType
): boolean => {
  return Object.values(data).some(
    item => item.status === QcReviewName.NEEDS_REVIEW
  );
};
